import { IUserReaction } from '@gem/models/reactionsModel';

import { Reaction } from 'APP/wsApi/wsAppApi/types/reaction/reaction_model_pb';

export function mapReactionToUserReaction(reaction: Reaction): IUserReaction {
  return {
    ...reaction,
    id: String(reaction.id),
  };
}
